<template>
  <div>
    <div v-if="inquiry.type==2">
      <template v-if="extras && extras.length">
        <Extras />
      </template>
      <template v-if="regions && regions.length">
        <ParamCheckboxes
          :translate="false"
          :label="$t('static_translation.ort')"
          :items="regions"
          :value="inquiry.regions"
          name="regions"
        /><br>
      </template>
      <div v-if="types.length>0">
        <ParamCheckboxes
          :value="inquiry.types"
          :label="$t('static_translation.unterkunft')"
          :items="types"
          name="types"
        /><br>
      </div>
    </div>
    <div v-if="inquiry.type === 2 && lodgings.length>0">
      <ParamCheckboxes
        :label="$t('static_translation.verpflegung')"
        :items="lodgings"
        :value="inquiry.lodgings"
        name="lodgings"
      />
    </div>

    <h4>{{ $t('static_translation.nachricht-an-den-vermieter') }} </h4>
    <div class="uk-margin-small-bottom tw-text-small uk-text-bold">
      {{ $t('static_translation.zusatzliche-angaben-oder-fragen-die-ihre-buchungsanfrage-betreffen') }}:
      <br>
    </div>
    <Row>
      <Col span="24">
      <FormItem>
        <Input
          v-model.trim="message"
          :rows="3"
          :placeholder="$t('static_translation.ihre-nachricht')"
          type="textarea"
        >
        </Input>
      </Formitem>
    </Col>
    </Row>
    <Checkbox
      v-model="saveInBrowser"
      :true-value="1"
    >
      <span class="checkboxes"> {{ $t('static_translation.daten-im-browser-fuer-aehnliche-anfrage-sichern') }}</span>
    </Checkbox>
    <div v-if="inquiry.is_late_exchange!=1">
      <div v-if="inquiry.type==3 || (inquiry.type==1 && inquiry.pool_id)">
        <Checkbox
          v-model="is_exchange"
          :true-value="1"
        >
          <span class="checkboxes">{{ $t('static_translation.bitte-geben-sie-meine-anfrage-an-andere-vermieter-weiter-wenn-sie-keine-freien-kapazitaten-mehr-haben') }}</span>
        </Checkbox>
      </div>
    </div>
    <h4>{{ $t('static_translation.zustimmung-zur-datenverarbeitung') }}</h4>

    <div
      v-if="!validated"
      class="uk-text-danger uk-text-bold blink-1"
      style="padding-top: 6px;"
    >
      <Alert
        type="error"
        style="font-size: 13px;"
      >
        {{ $t('static_translation.bitte-stimmen-sie-der-datenverarbeitung-zu-um-fortzufahren') }}
      </Alert>
    </div>
    <FormItem>
      <Checkbox v-model="GDPR">
        <span class="checkboxes gdpr">
          {{ gdprText }} (<a
            @click.stop.prevent="isPolicyVisible=true"
          >{{ $t('static_translation.datenschutzerklaerung') }}</a>).
        </span>
      </Checkbox>
    </FormItem>
    <Policy
      :is-visible="isPolicyVisible"
      @close="isPolicyVisible=false"
    />
  </div>
</template>
<script>
import {
  mapState
} from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import ParamCheckboxes from './ParamCheckboxes'
import Policy from './Policy'
import Extras from './Extras'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  components: {
    ParamCheckboxes, Policy, Extras
  },
  data () {
    return {
      validated: true,
      isPolicyVisible: false
    }
  },
  computed: {
    ...mapState({
      lodgings: state => state.store.lodgings,
      inquiry: state => state.store.inquiry,
      places: state => state.store.places,
      types: state => state.store.types,
      extras: state => state.store.extras,
      regions: state => state.store.regions
    }),
    ...mapFields([
      'inquiry.is_exchange',
      'inquiry.is_late_exchange',
      'inquiry.message',
      'inquiry.GDPR'
    ]),
    gdprText () {
      let text = ''
      if (this.is_late_exchange) {
        text = 'zustimmung-weitergabe'
      } else {
        text = (this.is_exchange) ? 'speicherung-verarbeitung-weitergabe' : 'speicherung-weitergabe'
      }
      return this.$t('static_translation.' + text)
    },
    saveInBrowser: {
      get () {
        return this.$store.state.store.saveInBrowser
      },
      set (value) {
        this.$store.commit('setSaveInBrowser', value)
      }
    }
  },
  mounted () {
    this.$bus.$on('validate-data', async (page) => {
      if (page === 'Message') {
        if (this.GDPR) {
          this.validated = true
          this.$emit('on-validated', page)
        } else {
          this.validated = false
        }
      }
    })
  }
}
</script>

<style>
  span.checkboxes  {
    display: table;
    padding-left: 24px;
    line-height: 1.4;
    font-size: 13px;
    line-height:1.4;
    margin-top:-16px;
  }
  span.checkboxes.gdpr  {
    line-height: 1.4;
    font-weight:bold;
    margin-top:-24px;
  }
</style>
